<template>
  <v-card class="orderManagement" flat>
    
    <AdminToolbar
      :searchTypes="searchTypes" 
      :search_condition.sync="search_condition"
      :sortTypes="sortTypes"
      :sort.sync="sort"
      :tabs="tabs"
      :tab.sync="tab"
      @searching="searching"
    ></AdminToolbar>

    <div class="table" v-infinite-scroll="getOrders" infinite-scroll-disabled="busy" infinite-scroll-distance="150">
      <v-row class="table-header" no-gutters>
        <v-col cols="2">訂單編號</v-col>
        <v-col>會員</v-col>
        <v-col>收件人</v-col>
        <v-col>收件人手機</v-col>
        <v-col>分店</v-col>
        <v-col>地址</v-col>
        <v-col>桃子</v-col>
        <v-col>運費</v-col>
        <v-col>建立時間</v-col>
        <v-col style="min-width: 50px; max-width: 50px" v-if="tab == 0"></v-col>
      </v-row>

      <div class="table-body">
        <template v-for="(order, i) in orders">
          <v-list-group class="order" :ref="`order${i}`" v-model="order.isOpen">
            <template v-slot:activator>
              <v-row class="table-content" no-gutters>
                <v-col>{{ order.order_number }}</v-col>
                <v-col>{{ order.member.nickname }}</v-col>
                <v-col>{{ order.name }}</v-col>
                <v-col>{{ order.tel }}</v-col>
                <v-col>{{ order.shop_name }}</v-col>
                <v-col>{{ order.shop_address }}</v-col>
                <v-col>
                  <div class="peach"></div>
                  {{ order.price }}
                </v-col>
                <v-col>
                  <div class="peach"></div>
                  {{ order.cart_orders.reduce((prev, cart_order) => {return prev + cart_order.fee}, 0) }}
                </v-col>
                <v-col>{{ order.checkout_time }}</v-col>
                <v-col style="min-width: 50px; max-width: 50px" v-if="tab == 0">
                  <v-btn icon color="indigo" @click.stop="$root.$emit('confirmDialog', () => shipAll(order), `確定寄出所有商品？`, 'fas fa-truck')">
                    <v-icon>fa-shipping-fast</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </template>
            <div class="pa-4 blue lighten-5 order">
              <div class="pa-4 seller" v-for="cart in order.cart_orders">
                <div class="d-flex align-center mb-2">
                  <div @click.capture.stop="$root.$emit('confirmDialog', () => shipSeller(cart, order), `確定${isSellerAllShip(cart) ? '取消' : ''}寄出該主播所有商品？`, 'fas fa-truck')">
                    <v-checkbox dense hide-details :input-value="isSellerAllShip(cart)"></v-checkbox>
                  </div>
                  <v-avatar size="25" class="mr-1">
                    <v-img :src="$HOST_URL + cart.seller.usericon"/>
                  </v-avatar>
                  {{ cart.seller.nickname }} ({{ cart.seller.id }})
                </div>
                <template v-for="cart_order in cart.orders">
                  <div class="d-flex py-2 align-center justify-space-between">
                    <div class="d-flex">
                      <span
                        class="d-flex align-center" 
                        @click.capture.stop="$root.$emit('confirmDialog', () => {
                        ship(cart_order, !cart_order.ship ? 1 : 0); checkIsAllShip(order)}, `確定${cart_order.ship ? '取消' : ''}寄出商品？`, 'fas fa-truck')"
                      >
                        <v-checkbox dense hide-details v-model="cart_order.ship"></v-checkbox>
                      </span>
                      <v-img aspect-ratio="1" max-width="60" width="60" :src="$func.productImagePreview(cart_order.product)"></v-img>
                      <div class="product-title">
                        <div>({{ cart_order.product.id }}) {{ cart_order.product.title }}</div>
                      </div>
                    </div>
                    <div class="d-flex align-center">
                      <div class="peach"></div>
                      {{ cart_order.product.price }}
                    </div>
                  </div>
                  <v-divider></v-divider>
                </template>
              </div>
            </div>
          </v-list-group>
        </template>
      </div>
    </div>
  </v-card>
</template>

<script>
import AdminToolbar from '@/components/admin/AdminToolbar'
export default {
  components: { AdminToolbar },
  data() {
    return {
      busy: false,
      page: 1,
      searchTypes: [
        { text: '訂單編號', table: 'carts', column: 'order_number' },
        { text: '收件人', table: 'carts', column: 'name' },
        { text: '收件人手機', table: 'carts', column: 'tel' },
        { text: '分店', table: 'carts', column: 'shop_name' },
        { text: '會員', table: 'members', column: 'nickname' },
        { text: '會員手機', table: 'members', column: 'tel' },
        { text: '會員Email', table: 'members', column: 'email' },
        { text: '主播暱稱', table: 'sellers', column: 'nickname' },
        { text: '主播手機', table: 'sellers', column: 'tel' },
        { text: '主播Email', table: 'sellers', column: 'email' },
      ],
      sortTypes: [
        { text: '建立日期', table: 'carts', column: 'checkout_time', by: 'desc' },
      ],
      tabs: [
        {text: '未完成出貨', value: 'unshipped'},
        {text: '已完成出貨', value: 'shipped'},
      ],
      tab: 0,
      sort: '',
      search_condition: [],
      orders: [],
    }
  },
  methods: {
    searching() {
      this.busy = false
      this.page = 1
      this.orders = []
      this.getOrders()
    },
    getOrders() {
      this.busy = true
      let search_condition = this.search_condition.concat({table: 'orders', column: 'ship', keyword: [this.tab, this.tab]})
      let origin = this.tab
      this.axios.post('/admin/orders', {
        search: search_condition,
        page: this.page,
        size: 50,
        sort: this.sort,
      }).then(response => {
        if(origin != this.tab) {
          return
        }
        this.orders = this.orders.concat(response.data.data.filter(order => order.cart_orders.length))
        if(this.page != response.data.last_page) {
          this.page += 1
          this.busy = false
        }
      })
    },
    ship(cart_order, value) {
      cart_order.ship = value
      this.axios.post(`/admin/order/ship/${cart_order.id}`, {
        ship: value
      })
    },
    shipSeller(cart, order) {
      let value = !this.isSellerAllShip(cart) ? 1 : 0
      cart.orders.forEach(cart_order => {
        this.ship(cart_order, value)
      })
      this.checkIsAllShip(order)
    },
    shipAll(order) {
      order.cart_orders.forEach(cart => {
        cart.orders.forEach(cart_order => {
          this.ship(cart_order, 1)
        })
      })
      this.checkIsAllShip(order)
    },
    isSellerAllShip(cart) {
      return cart.orders.every(cart_order => cart_order.ship)
    },
    checkIsAllShip(order) {
      let allShip = order.cart_orders.every(cart => {
        return cart.orders.every(cart_order => cart_order.ship)
      })
      let i = this.orders.indexOf(order)
      if((allShip && this.tab == 0) || (!allShip && this.tab == 1)) {
        order.isOpen = false
        this.orders.splice(i, 1)
      }
    }
  }
}
</script>

<style lang="scss">
.orderManagement {
  .order {
    font-size: 14px;
    padding: 8px 12px;
    .v-list-group__header {
      padding: 0;
      .v-list-group__header__append-icon {
        display: none;
      }
    }
    .col {
      padding: 0 12px;
    }
    .seller {
      background-color: white;
      a {
        color: unset !important;
      }
      .product-title {
        font-size: 14px;
        padding: 0 120px 0 12px;
      }
      .product-price {
        float: right;
      }
    }
  }
}
</style>